// 詳細画面のAPIコールを行うカスタムhook
import React, { useState } from 'react';
import { releaseBrowserBack } from '../BrowserBack';
import {
  ChildShelf,
  Content,
  FormResponse,
  AutoInput,
  DialogState,
  PostData,
  DialogRespose,
  ResponsData,
  GuarantorInfo,
  OnlineIdentificationRespose,
} from '../types/Template';
import {
  tmp_init,
  api_response_type,
  dialog_type,
  dialog_function,
  download_wait_time,
  loding_close_timmer,
  content_type,
  shelf_type,
  guarantors_limit,
  status_code_list,
} from '../Const';
import axios from '../axios';
import { useFilterGuarantor } from './Guarantor';
import { editModalBody } from '../EditModal';
import { jumpUrl, authErrorTimeout } from '../Common';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../BrowserJudgment';
import { fileDownload } from '../FileDownload';
import { convertApiData } from '../Convert';
import { getTargetById, targetMovePoint } from '../Scroll';
import { FilterGuarantorsShelfs } from '../FilterGuarantorsShelfs';

export const useCallApi = (
  child_shelfs: ChildShelf[],
  contents: Content[],
  setContents: React.Dispatch<React.SetStateAction<Content[]>>,
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>,
  reception_id: number,
  reception_cd: string,
  status_code: number,
  is_staff: boolean,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  guarantor_info: GuarantorInfo,
  setOnlineIdentificationModalOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [guarantors_num, setGuarantorsNum] = useFilterGuarantor(contents);
  const [show_error_nav, setShowErrorNav] = useState(false);
  const [api_response_detail, setApiResponseDetail] = useState({});
  /**
   * API呼び出し共通ファンクション
   * @param function_name 呼び出しモジュール名
   * @param should_loading ローディング表示判定
   * @param show_error エラーナビゲーション表示判定
   * @return void | boolean
   */
  const requestModule = (function_name: string, should_loading = true, show_error = false) => {
    const filtering_shelf = FilterGuarantorsShelfs(guarantor_info, child_shelfs, guarantors_num);
    const post_data: PostData = {
      reception_id: reception_id,
      reception_cd: reception_cd,
      status: status_code,
      module_name: function_name,
      detail: convertPostData(filtering_shelf),
      is_json: true,
    };
    return postData(post_data, should_loading, show_error);
  };

  /**
   * API呼び出し共通ファンクション
   * @param function_name 呼び出しモジュール名
   * @param new_contents 更新後のステートcontents
   * @param should_loading ローディング表示判定
   * @param show_error エラーナビゲーション表示判定
   * @return void | boolean
   */
  const requestModuleWithNewContents = (function_name: string, new_contents: Content[], should_loading = true, show_error = false) => {
    const filtering_shelf = FilterGuarantorsShelfs(guarantor_info, child_shelfs, guarantors_num);
    const post_data: PostData = {
      reception_id: reception_id,
      reception_cd: reception_cd,
      status: status_code,
      module_name: function_name,
      detail: convertPostDataFromNewContents(filtering_shelf, new_contents),
      is_json: true,
    };
    return postData(post_data, should_loading, show_error);
  };

  /**
   * APIに値をPOSTする
   *
   * @param post_data リクエストデータ
   * @param should_loading ローディング表示判定
   * @param show_error エラーナビゲーション表示判定
   */
  const postData = async (post_data: PostData, should_loading: boolean, show_error: boolean) => {
    try {
      setIsLoading(should_loading);
      setShowErrorNav(show_error);
      // APIにデータをPOSTする
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, post_data);
      // 正常なレスポンス
      if (response.data.result) {
        return allocationResponseData(response.data, post_data.module_name);
        // 異常なレスポンス
      } else {
        setIsLoading(false);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      jumpUrl(error.response.data.url);
      // 遷移先URLが取れない場合はステータスコードで判断する
      if (!error.response.data.url) {
        authErrorTimeout(error.response.status);
      }
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * レスポンス結果から画面処理を振り分ける
   * Note sakuma 現行の仕様に合わせて要修正
   *
   * @param reasponse_data API返却値
   * @param module_name モジュール名
   */
  const allocationResponseData = (reasponse_data: ResponsData, module_name: string) => {
    switch (reasponse_data.response_type) {
      case api_response_type.page_transition: // 画面遷移
        pageTransition(reasponse_data.reception_cd, reasponse_data.reception_id);
        break;
      case api_response_type.dialog: // ダイアログ表示
        showResponseDialog(reasponse_data.detail);
        break;
      case api_response_type.validation: // バリデーション
        return setValidMessage(reasponse_data.detail);
      case api_response_type.list: // リスト
        break;
      case api_response_type.auto_input: // 指定項目の自動入力
        setDataAutoInput(reasponse_data.detail);
        break;
      case api_response_type.transition_to_list: // 一覧画面に遷移
        transitionToList();
        break;
      case api_response_type.online_identification: // オンライン本人確認
        onlineIdentification(reasponse_data.detail);
        break;
      case api_response_type.transition_to_borrowing_application: // 借入申込詳細画面へ遷移
      case api_response_type.transition_to_agriculture_borrowing_application: // 農業資金借入申込詳細画面へ遷移
      case api_response_type.transition_to_borrowing_consultation_updating: // 借入相談入力画面へ遷移
      case api_response_type.transition_to_borrowing_consultation_changing: // 借入相談入力(変更)画面へ遷移
      case api_response_type.transition_to_pre_examination_input_housing_loan_firmly: // 住宅ローンしっかり審査事前審査申込入力詳細に遷移
        transitionToBorrowingApplicationOrPreExaminationInputHousingLoanFirmly(reasponse_data);
        break;
      case api_response_type.transition_to_mypage: // マイページ開設同意画面への遷移
        transitionToMypage();
        break;
      case api_response_type.navigation_finish: // それぞれの申込完了画面に遷移
      setApiResponseDetail(reasponse_data.detail);
        return true;
      case api_response_type.temporarily_saved: // 一時保存完了
        return true;
      case api_response_type.transition_to_contract_signature: // 契約書署名画面に遷移
        transitionToContractSignature(reasponse_data);
        break;
      case api_response_type.download: // pdfダウンロード
        downloadPdf(module_name);
        break;
      case api_response_type.modernization_funds_application_category_temporarily_saved: //「申込区分」の値でテンプレート切り替え時の一時保存成功時
        setShowErrorNav(false);
        return true;
      case api_response_type.transition_to_ekyc_error: // eKYCエラー画面に遷移
        transitionToEkycError();
        break;
      case api_response_type.modernization_fund_init_reg_complete: // 入力種別選択画面に遷移
        transitionToModernizationFundsInputTypeSelect(reasponse_data);
        break;
      default:
        break;
    }
  };

  /**
   * 更新された値を使用し、次の詳細画面を表示します。
   * @param reception_cd 案件コード
   * @param reception_id 案件id
   */
  const pageTransition = (reception_cd: string, reception_id: number) => {
    setIsLoading(false);
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}/${status_code}`;
  };

  /**
   * レスポンスからダイアログを生成する
   * Note sakuma 現行の仕様に合わせて要改修
   * @param response_detail レスポンス値
   * @param pb_id 親棚ID
   * @param cb_id 小棚ID
   */
  const showResponseDialog = (response_detail: DialogRespose) => {
    const post_data: PostData = {
      reception_id: reception_id,
      reception_cd: reception_cd,
      status: status_code,
      module_name: '',
      detail: [],
      is_json: true,
    };
    // 応答結果からボタン押下時のイベントハンドラ作成
    // Note sakuma モーダルの表示非表示処理を追加
    const event_handler = response_detail.btn_function.map((function_name: string) => {
      return function_name !== ''
        ? // APIコール
          () => {
            post_data.module_name = function_name;
            postData(post_data, true, false);
            // setResponseDialogState(dialog_init);
          }
        : // モーダルを閉じる
          () => {
            // setResponseDialogState(dialog_init);
          };
    });
    // ダイアログの状態を更新
    const dialog_state: DialogState = {
      is_confirm: response_detail.dialog_type === dialog_type.confirm,
      show: true,
      title: response_detail.dialog_title,
      body: editModalBody(response_detail.dialog_message),
      ClickConfirm: event_handler[dialog_function.confirm],
      ClickYes: event_handler[dialog_function.yes],
      ClickNo: event_handler[dialog_function.no],
    };
    // setResponseDialogState(dialog_state);
    setIsLoading(false);
  };

  /**
   * 対応する案件一覧に遷移する
   */
  const transitionToList = () => {
    is_staff
      ? location.replace(`${process.env.MIX_MOCK_URL}/staff/list${location.search}`)
      : location.replace(`${process.env.MIX_MOCK_URL}/mypage/list`);
    setTimeout(() => setIsLoading(false), loding_close_timmer);
  };

  /**
   * オンライン本人確認の結果によってbool値を返却する
   * @param details レスポンスの値
   */
  const onlineIdentification = (details: OnlineIdentificationRespose) => {
    // ekYC画面を新規ウィンドウ（タブ）表示
    window.open(details.ekycUrl);
    // 本人確認実施中のダイアログを表示
    setOnlineIdentificationModalOpen(true);
  };
  /**
   * バリデーション結果を画面に表示する
   *
   * @param detail バリデーション結果
   */
  const setValidMessage = (details: Array<FormResponse>) => {
    if (details.length === 0) {
      setContents(prev =>
        prev.map(value => {
          return {
            ...value,
            message: undefined, // メッセージを初期化する
          };
        })
      );
      setShowErrorNav(false);
      return true;
    }

    setContents(prev =>
      prev.map(value => {
        // 同じカラム名 & 活性項目のバリデーションメッセージを表示
        let tmp_value: Content = tmp_init;
        for (const detail of details) {
          if (value.field_column_name === detail.form_name && !value.disabled) {
            tmp_value = {
              ...value,
              message: detail.message,
            };
            break;
          } else {
            tmp_value = {
              ...value,
              message: undefined, // メッセージを初期化する
            };
          }
        }
        return tmp_value;
      })
    );
    // エラー項目のインデックス番号を取得
    const index = getTargetIndex(details);
    // バリデーションエラーがある場合、対象の棚を開く
    OpenTargetShelf(index);
    setIsLoading(false);
    setShowErrorNav(true);
    return false;
  };

  /**
   * インデックス番号を取得する
   *
   * @param details バリデーション結果
   */
  const getTargetIndex = (details: Array<FormResponse>) => {
    return contents.findIndex(
      value => !value.disabled && value.field_column_name === details[0].form_name
    );
  };

  /**
   * バリデーションエラーがある場合、対象の棚を開く
   *
   * @param index index番号
   */
  const OpenTargetShelf = (index: number) => {
    if (index >= 0) {
      // 対象の棚を開く
      setChildShelfs(prev =>
        prev.map(child_shelf =>
          // 最初の項目を持つ棚のみ開く
          contents[index].cb_id === child_shelf.cb_id
            ? { ...child_shelf, cb_open: true }
            : child_shelf
        )
      );
      // バリデーション項目にフォーカスイン
      const { target_element, scroll_option } = getTargetById(contents, index);
      // Note：棚の開閉が完了した後に移動するようインターバルを設ける
      targetMovePoint(target_element, scroll_option);
    }
  };

  /**
   * pdfをダウンロードする
   * @param module_name 通信対象モジュール名
   * @return void
   */
  const downloadPdf = async (module_name: string) => {
    const post_data: PostData = {
      module_name: module_name,
      reception_cd: reception_cd,
      reception_id: reception_id,
      status: status_code,
      is_json: false,
      detail: [],
    };
    try {
      const start_time = performance.now(); // 開始時間
      setIsLoading(true);
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, post_data, {
        responseType: 'blob',
      });
      // ファイルダウンロード
      if (response.headers['content-type'] === content_type.pdf) {
        //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
        if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
          releaseBrowserBack();
        }

        fileDownload(response.data, response.headers['content-disposition'], content_type.pdf);
      } else {
        // pdf以外許容しないため、ダイアログ表示
        // showExceptionDialog('システムエラーが発生しました');
      }
      // ローディング停止を遅らせる
      const end_time = performance.now(); // 終了時間
      setTimeout(() => {
        setIsLoading(false);
      }, download_wait_time - (end_time - start_time));
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  // eKYCエラー画面に遷移
  const transitionToEkycError = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/ekyc/error`;
  };

  /**
   * 入力種別選択画面に遷移
   *
   * @param response_data レスポンスデータ
   */
  const transitionToModernizationFundsInputTypeSelect = (response_data: ResponsData) => {
    // 現在の案件のステータスが2500の場合はSessionStorageに遷移元URLを保存する
    if (location.href.indexOf('/2500') !== -1) {
      sessionStorage.setItem('modernization_funds_input_type_select_referer', location.href);
    }

    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/modernization_funds/input_type_select/${response_data.reception_cd}/${response_data.reception_id}`;
  }

  /**
   * 指定項目に自動入力する
   * @param details APIレスポンス
   */
  const setDataAutoInput = (details: AutoInput[]) => {
    setContents(prev => {
      return details.reduce((previous, detail) => {
        const target_index = previous.findIndex(
          value => value.field_column_name === detail.form_name
        );
        const array = previous.slice(); // ディープコピー
        array[target_index].value = detail.value ?? '';
        array[target_index].message = detail.message ?? undefined;

        // バリデーションメッセージがない場合、早期リターン
        if (typeof detail.message === 'undefined' || detail.message === null) {
          setShowErrorNav(false);
          return array;
        }
        // バリデーションメッセージを取得
        array[target_index].message = detail.message;
        setShowErrorNav(true);
        // インデックス番号を取得
        const index = getTargetIndex(details);
        // バリデーションエラーがある場合、対象の棚を開く
        OpenTargetShelf(index);
        return array;
      }, prev);
    });
    setIsLoading(false);
  };

  /**
   * 更新後のstatusを取得する
   * @retuns 変更後のステータス番号
   */
  const getNextStatus = () => {
    switch (status_code) {
      case status_code_list.borrowing_consultation_disagreed: //ステータス1260に場合、ステータス1200を返却する
        return status_code_list.borrowing_consultation_updating;

      case status_code_list.preliminary_review_disagreed: //ステータス1760に場合、ステータス1710を返却する
        return status_code_list.preliminary_review_updating;

      case status_code_list.borrowing_consultation_result_approval: //ステータス1500または2000の場合、ステータス2300を返却する
      case status_code_list.pre_examination_result_approval:
        return status_code_list.borrowing_application_input;

      case status_code_list.borrowing_application_disagreement: //ステータス2500の場合、ステータス2200を返却する
        return status_code_list.borrowing_application_change;

      default:
        return;
    }
  };

  /**
   * 借入申込詳細画面、住宅ローンしっかり審査事前審査申込入力詳細に遷移に遷移
   *
   * @param response_data レスポンスデータ
   */
  const transitionToBorrowingApplicationOrPreExaminationInputHousingLoanFirmly = (
    response_data: ResponsData
  ) => {
    const status = getNextStatus();
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/reception/${response_data.reception_cd}/${response_data.reception_id}/${status}`;
  };

  /**
   * 契約書署名画面に遷移
   *
   * @param response_data レスポンスデータ
   */
  const transitionToContractSignature = (response_data: ResponsData) => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/applicant/contract_signature?r_id=${reception_id}`;
  };

  /**
   * 対応するマイページ開設同意確認画面に遷移する
   */
  const transitionToMypage = async () => {
    try {
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/agreement/store`, {
        reception_cd: reception_cd,
        reception_id: reception_id,
      });
      location.href = response.data.url;
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => setIsLoading(false), loding_close_timmer);
    }
  };

  /**
   * 送信する値を厳選, 変換する
   *
   * @param {number[]} filtering_shelf
   * @return {*}
   */
  const convertPostData = (filtering_shelf: number[]) => {
    // 送信データを取得
    return contents
      .filter(content => {
        return (
          !content.disabled &&
          content.field_column_name !== null &&
          !filtering_shelf.includes(content.cb_id)
        );
      })
      .map(data => {
        // POSTする値を適切な形に変換する
        const converted_value: string | number | Date = convertApiData(
          data.fm_type,
          data.value,
          data.input_assistance
        );

        return { id: data.fm_id, name: data.field_column_name, value: converted_value };
      });
  };

  /**
   * 送信する値を厳選, 変換する
   *
   * @param {number[]} filtering_shelf
   * @param {Content[]} new_contents
   * @return {*}
   */
  const convertPostDataFromNewContents = (filtering_shelf: number[], new_contents: Content[]) => {
    // 送信データを取得
    return new_contents
      .filter(content => {
        return (
          !content.disabled &&
          content.field_column_name !== null &&
          !filtering_shelf.includes(content.cb_id)
        );
      })
      .map(data => {
        // POSTする値を適切な形に変換する
        const converted_value: string | number | Date = convertApiData(
          data.fm_type,
          data.value,
          data.input_assistance
        );

        return { id: data.fm_id, name: data.field_column_name, value: converted_value };
      });
  };

  return { setShowErrorNav, show_error_nav, requestModule, api_response_detail, requestModuleWithNewContents };
};
